module.exports = __webpack_public_path__ + "static/flags/IV-6a983821381d5267c17fbec62099063f.gif";